import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'investorId',
    label: 'Investor',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'investorLoanNumber',
    label: 'Investor Loan Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'commitmentNumber',
    label: 'Commitment Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'investorPrice',
    label: 'Investor Price',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'investorLockDate',
    label: 'Investor Lock Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'investorLockExpiration',
    label: 'Investor Lock Expiration',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const sellSideLockForm = {
  name: FormNames.SELL_SIDE_LOCK,
  label: 'Sell Side Lock',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
